import script from "./addkejian.vue?vue&type=script&setup=true&lang=js"
export * from "./addkejian.vue?vue&type=script&setup=true&lang=js"

import "./addkejian.vue?vue&type=style&index=0&id=ac12f84a&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac12f84a"]])

export default __exports__